import {Button} from "antd";
import {AppstoreAddOutlined} from "@ant-design/icons";

export interface SaveButtonProps {
    onSave: () => void;
    disabled?: boolean;
}

const AddButton: React.FC<SaveButtonProps> = (props) => {
    const { onSave, disabled } = props;

    return (
        <Button type={"primary"}  onClick={onSave} block disabled={disabled} style={{fontSize: "large"}} icon={<AppstoreAddOutlined />}>
            Add new
        </Button>
    );
};

export default AddButton;